export default __webpack_public_path__ + "static/laffayette_comic_pro-webfont-10c42c92e2bbd32f22b06cc7fdae2d4a.eot";